import { TSvgComponentProps } from '../../../../types';

export function VerticalSingleEndBannerSVG(props: TSvgComponentProps) {
  return (
    <svg
      enableBackground="new 0 0 180 210"
      id="banner"
      version="1.1"
      viewBox="0 0 180 210"
      x="0"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      y="0"
      {...props}
    >
      <radialGradient
        cx="81.479"
        cy="102.383"
        fx="235.082"
        fy="109.528"
        gradientTransform="matrix(.9921 -.1256 .04069 .3214 -3.52 79.705)"
        gradientUnits="userSpaceOnUse"
        id="body-shadow"
        r="153.769"
      >
        <stop offset="0.314" stopOpacity="0.8" />
        <stop offset="1" stopOpacity="0.9" />
      </radialGradient>
      <path
        d="M10.2 16.3c-3.5.7-3.7 41.2-3.7 88l1.7 99.2L87 151.6l75.7 54.4s-6.4-74.8-4.9-101.7C159.1 82 173.6 23 173.6 23L10.2 16.3z"
        fill="url(#body-shadow)"
        id="body-shadow"
        opacity="0.15"
      />
      <linearGradient
        gradientTransform="matrix(1 0 0 -1 0 -224.11)"
        gradientUnits="userSpaceOnUse"
        id="body"
        x1="89.263"
        x2="73.841"
        y1="-428.176"
        y2="-232.229"
      >
        <stop offset="0.5" stopColor="#a64ef2" />
        <stop offset="0.72" stopColor="#a44df0" />
        <stop offset="0.8" stopColor="#9f49e9" />
        <stop offset="0.86" stopColor="#9643dd" />
        <stop offset="0.91" stopColor="#893bcc" />
        <stop offset="0.95" stopColor="#7930b6" />
        <stop offset="0.98" stopColor="#65239c" />
        <stop offset="1" stopColor="#591c8c" />
      </linearGradient>
      <path
        d="M8.2 13.3c-3.5.7-3.7 41.2-3.7 88v97.4l76.7-51 76.7 51V3.7L8.2 13.3z"
        fill="url(#body)"
        id="body"
      />
      <path
        d="M173.6 23c-1.5.2-6.4-.1-8.7-3.9l-2.3-8.9 10.9-1c2.2 11.6.7 13.8.1 13.8z"
        fill="#702bb2"
        id="hanger_shadow"
      />
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="hanger-body"
        x1="86.703"
        x2="78.065"
        y1="94.116"
        y2="29.131"
      >
        <stop offset="0.658" stopColor="#a54df1" stopOpacity="0.8" />
        <stop offset="0.706" stopColor="#9442da" stopOpacity="0.772" />
        <stop offset="0.789" stopColor="#7a32b8" stopOpacity="0.724" />
        <stop offset="0.868" stopColor="#6826a0" stopOpacity="0.677" />
        <stop offset="0.94" stopColor="#5d1e91" stopOpacity="0.635" />
        <stop offset="1" stopColor="#591c8c" stopOpacity="0.6" />
      </linearGradient>
      <path
        d="M8.2 13.3c-2.4.5-3.3 20.2-3.6 47.9-.1 12.1-.2 25.8-.2 40l153.4-58.1V3.7L8.2 13.3z"
        fill="url(#hanger-body)"
        id="hanger-body"
      />
      <linearGradient
        gradientTransform="matrix(1 0 0 -1 0 -224.11)"
        gradientUnits="userSpaceOnUse"
        id="hanger-highlight"
        x1="91.971"
        x2="89.87"
        y1="-254.27"
        y2="-230.252"
      >
        <stop offset="0.09" stopColor="#5600a0" />
        <stop offset="0.21" stopColor="#6e21b0" />
        <stop offset="0.48" stopColor="#a168d3" />
        <stop offset="0.67" stopColor="#c194e9" />
        <stop offset="0.77" stopColor="#cea5f2" />
        <stop offset="0.8" stopColor="#cb9ff2" />
        <stop offset="0.84" stopColor="#c490f2" />
        <stop offset="0.89" stopColor="#b977f2" />
        <stop offset="0.94" stopColor="#a953f2" />
        <stop offset="0.99" stopColor="#9426f2" />
        <stop offset="1" stopColor="#911ff2" />
      </linearGradient>
      <path
        d="M159.1.3c3.6-.9 6.2 6.3 8.7 12.9 1.7 4.4 3.5 10 5.9 9.8L22.4 36.2C16 37.3 13.1 13.1 8.2 13.3L159.1.3z"
        fill="url(#hanger-highlight)"
        id="hanger-highlight"
      />
    </svg>
  );
}
